<template>
  <el-form ref="formData" name="formData" :model="formData" label-width="110px" :rules="rules">
    <el-form-item :label="title + 'IP'" prop="ip">
      <el-col :span="20">
        <el-input v-model="formData.ip" placeholder="请输入ip"></el-input>
      </el-col>
    </el-form-item>


    <el-form-item :label="title + '端口'"  :rules="rangeHasData ? {} : rules.requiredItem">
      <div v-for="(port, index) in formData.ports" :key="index">
        <el-col :span="20" class="portDiv">
          <el-form-item :prop="'ports.'+index+'.value'" :rules="rules.port">
          <el-input v-model="port.value" placeholder="请输入端口号" type="number" min="0"></el-input>
          </el-form-item>
        </el-col>
        <el-col align="center" :span="2" class="operateIcon">
          <div class="el-icon-circle-plus" @click="addPort"></div>
        </el-col>
        <el-col align="center" :span="2" class="operateIcon" v-if="formData.ports.length > 1">
          <div class="el-icon-delete-solid" @click="delPort(index)"></div>
        </el-col>
      </div>
    </el-form-item>


    <el-form-item :label="title + '端口范围'" :rules="portHasData ? {} : rules.requiredItem">
      <div v-for="(range, index) in formData.portRange" :key="index">
        <el-col :span="9" class="portDiv">
          <el-form-item :prop="'portRange.'+index+'.start'" :rules="rules.port">
            <el-input v-model="range.start" type="number" min="0"></el-input>
          </el-form-item>
        </el-col>
        <el-col align="center" :span="2">-</el-col>
        <el-col :span="9" class="portDiv">
          <el-form-item :prop="'portRange.'+index+'.end'" :rules="rules.port">
            <el-input v-model="range.end" type="number" min="0"></el-input>
          </el-form-item>
        </el-col>
        <el-col align="center" :span="2" class="operateIcon">
          <div class="el-icon-circle-plus" @click="addRange"></div>
        </el-col>
        <el-col align="center" :span="2" class="operateIcon" v-if="formData.portRange.length > 1">
          <div class="el-icon-delete-solid" @click="delRange(index)"></div>
        </el-col>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "NetworkItem",
  props: {
    title: {
      type: String
    },
    networkItem: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    let validateIP = (rule, value, callback) => {
      if(value && "..." === value){
        callback(new Error('请输入IP地址'))
      }if (value && !(/((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/).test(value)) {
	      callback(new Error('IP地址不规范'))
	    } else {
	      callback()
      }
    }
    /*
    * 算法：
    *   1.默认兄弟端口都是校验通过的，取出所有的兄弟端口(ports + portRange)，存于set中
    *   2.检查set中是否含有当前的端口，如果有，返回；如果没有，深入检查：
    *     2.1. 如果当前端口是ports里的，在set中添加该端口，否则2.2
    *     2.2. 如果当前端口是start(end)，取对应的end(start)值：
    *       2.2.1. end(start)值为空：在set中添加，否则2.2.2
    *       2.2.2. start~end范围内所有的值，如果都不在set中，在set中添加，否则返回
    *
    */
    let validateport = (rule, value, callback) => {
      if(value == ''){
        return
      }
      const val = Number(value)
      //field---0.portRange/ports   1.下标  2.value/start/end
      const field = rule.field.split('.')
      const ports = this.formData.ports
      const portRange = this.formData.portRange
      let arr = new Set() //所有的端口
      let broPort = [], broRange= [] //兄弟端口
      let flag = 0
      if(field[0] == 'ports'){
        broPort = ports.filter((p, id)=> id != Number(field[1]))
        broRange = portRange
      }else{
        broPort = ports
        broRange = portRange.filter((pr, id) => id != Number(field[1]))
      }
      broPort.forEach(b => {
        if(b.value == ''){
          return
        }
        arr.add(Number(b.value))
      })
      broRange.forEach(br => {
        if(br.start == '' || br.end == ''){
          return
        }
        for(let i= Number(br.start); i<= Number(br.end); i++){
          arr.add(i)
        }
      })

      if(arr.has(val)){
        callback(new Error('该端口已存在'))
        return
      }else if(field[0] == 'ports'){
        arr.add(val)
      }else{
        let start, end
        if(field[2] == 'start'){
          start = val
          end = Number(this.formData.portRange[field[1]].end)
        }else{
          end = val
          start = Number(this.formData.portRange[field[1]].start)
        }

        if(start != '' && end !=''){
          if(start >= end){
            callback(new Error('开始端口要小于结束端口'))
            return
          }
          let note = 0
          for(let i = start; i<= end; i++){
            if(arr.has(i)){
              note = 1
              break;
            }
          }
          if(note == 0){
            flag = 1
            for(let i = start; i<= end; i++){
              arr.add(i)
            }
          }else{
            callback(new Error('端口已存在'))
          }
        }
      }

      if(flag == 1){
        callback()
      }
    }
    return {
      portArr: [],
      portObj: {
        ports: new Set(),
        portRange: new Set()
      },
      allPort: {},
      formData: {

      },
      networkCardItem: {
        ip: "",
        ports: [
          {
            value: ""
          }
        ],
        portRange: [
          {
            start: "",
            end: ""
          }
        ]
      },
      rules: {
        requiredItem: [{ required: true, message: '该项是必填项',trigger: 'blur'}],
        ip: [
          { required: true, message: '该项是必填项'},
          { validator: validateIP, trigger: 'blur'}
        ],
        port: [{ validator: validateport, trigger: 'blur'}],
      }
    };
  },
  computed:{
    rangeHasData(){
      const range = this.formData.portRange ? this.formData.portRange : []
      const exist = range.some(r => r.start!='' && r.end!='' && r.start>=0 && r.end<=65535)
      return exist
    },
    portHasData(){
      const ports = this.formData.ports ? this.formData.ports : []
      const exist = ports.some(p => p.value != '')
      return exist
    }
  },
  watch: {
    formData: {
      handler (newVal, oldVal) {
        this.$emit('update:networkItem', newVal)
      },
      deep: true //是否深度监听
    },
    networkItem: {
      handler (newVal, oldVal) {
        const data = newVal
        if(data.ports.length == 0){
          data.ports = [{value: ''}]
        }
        if(data.portRange.length == 0){
          data.portRange = [{'start':'', "end": ''}]
        }
        this.formData = data
      },
      deep: true //是否深度监听
    },
    // 'networkItem.ip'
  },
  mounted() {
    this.formData = Object.assign(this.networkCardItem, this.networkItem)
  },
  methods: {
    addPort() {
      this.formData.ports.push({
        value: ""
      });
    },
    addRange() {
      this.formData.portRange.push({
        start: "",
        end: ""
      });
    },
    delPort(idx) {
      this.formData.ports.splice(idx, 1);
    },
    delRange(idx) {
      this.formData.portRange.splice(idx, 1);
    }
  }
};
</script>

<style scoped>
.operateIcon {
  cursor: pointer;
}
.portDiv {
  margin-bottom: 20px;
}
</style>
